import { datadogRum } from '@datadog/browser-rum';
import React, { useEffect } from 'react';
export const MetricsAgent = React.memo(function MetricsAgent({ session, isWindowsApp, }) {
    useEffect(() => {
        if (session) {
            datadogRum.setUser({
                id: session.id,
                name: session.name ?? '',
                email: session.email,
                orgId: session.orgId,
            });
            datadogRum.setGlobalContextProperty('isPro', session.isPro);
            datadogRum.setGlobalContextProperty('tier', session.tier);
            datadogRum.setGlobalContextProperty('isEnterprise', session.isEnterprise);
            datadogRum.setGlobalContextProperty('isWindowsApp', isWindowsApp);
        }
    }, [session, isWindowsApp]);
    return null;
});
//# sourceMappingURL=MetricsAgent.js.map